import { render } from "./editBankDetail.vue?vue&type=template&id=6c8b785e"
import script from "./editBankDetail.vue?vue&type=script&lang=js"
export * from "./editBankDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__